<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ title }}</strong>
                </CCardHeader>

                <CCardBody>
                    <div class="table__preloader" v-if="loading">
                        <CSpinner color="primary"/>
                    </div>
                    <template v-else>
                        <CompaniesTable
                            :data.sync="list"
                            :service="service"
                            unarchivable
                            @unarchived="onUnarchived"
                        />
                    </template>
                </CCardBody>
                <CCardFooter>
                    <CLink :to="backLink">← К списку</CLink>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import CompaniesTable from '@/components/CompaniesTable';

    export default {
        name: 'CompaniesArchive',

        components: {
            CompaniesTable,
        },

        props: {
            title: {
                type: String,
                required: true,
            },
            backLink: {
                type: String,
                required: true,
            },
            apiPath: {
                type: String,
                required: true,
            },
            service: {
                type: String,
                required: true,
            },
        },

        data: () => ({
            loading: true,
            list: [],
        }),

        async mounted() {
            await this.fetch();
        },

        methods: {
            async fetch() {
                this.loading = true;
                try {
                    const { data } = await this.axios.get(this.apiPath, {
                        params: { archive: true },
                    });
                    this.list = data;
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                } finally {
                    this.loading = false;
                }
            },
            onUnarchived(id) {
                this.list = this.list.filter(item => item.id !== id);
            },
        },
    };
</script>
